import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "location-selection-wrap" }
const _hoisted_2 = { class: "main-menu" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "name" }

import AppActivity from "@/components/AppActivity.vue";
import {
  ICON_CONFIGURE,
  ICON_EXIT,
  ICON_INFORMATION_ICON,
  ICON_OPTIMIZE,
  ICON_START_CHECK,
  ICON_START_REPORT
} from "@/lib/icons";
import {useStore} from "vuex";
import router from "@/router";
import {showAlert, showSnackbar} from "@/store";
import {useApiClient} from "@/api";
import {computed} from "vue";
import LocationSelection from "@/components/LocationSelection.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuActivity',
  setup(__props) {

const store = useStore()

const icons = [
    ICON_EXIT,
]

const fabIcons = [
    ICON_INFORMATION_ICON,
]

const menuIcons: { icon: string, name: string }[] = [
  {
    icon: ICON_START_CHECK,
    name: 'Check starten'
  },
  {
    icon: ICON_START_REPORT,
    name: 'Ergebnisse'
  },
  {
    icon: ICON_OPTIMIZE,
    name: 'Optimierungs- vorschläge'
  },
  {
    icon: ICON_CONFIGURE,
    name: 'Einstellungen'
  },
]

const isOffline = computed(() => store.state.offline.isOffline)

const onMenuAction = (icon: string) => {
  switch (icon) {
    case ICON_START_CHECK:
      router.push({ name: 'questionnaire', params: { mode: 'check' }})
      break;
    case ICON_START_REPORT:
      if (isOffline.value) {
        showAlert("Sie sind OFFLINE. Die Fragebögen können nur ausgewertet werden, wenn Sie mit dem Internet verbunden sind!")
      } else {
        router.push({ name: 'questionnaire', params: { mode: 'analyze' }})
      }
      break;
    case ICON_OPTIMIZE:
      if (isOffline.value) {
        showAlert("Sie sind OFFLINE. Die Optimierungen können nur abgerufen werden, wenn Sie mit dem Internet verbunden sind!")
      } else {
        router.push({ name: 'questionnaire', params: { mode: 'optimize' }})
      }
      break;
    case ICON_CONFIGURE:
      router.push({ name: 'login' })
      break
    default:
      showAlert(menuIcons.filter(i => i.icon === icon)[0].name)
  }
}

const onFabAction = (icon: string) => {
  if (icon === ICON_INFORMATION_ICON) {
    showSnackbar('Current-Version: 12')
  }
}

const onExit = () => {
  if (navigator.app) {
    navigator.app.exitApp();
  } else if (navigator.device) {
    navigator.device.exitApp();
  } else {
    window.close();
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppActivity, {
    title: "Risiko - Analyse",
    icons: icons,
    onIconClick: onExit,
    "fab-icons": fabIcons,
    onFabIconClick: onFabAction,
    vertical: "center",
    "full-size": "",
    id: "menu-activity"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(LocationSelection)
      ]),
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuIcons, (icon) => {
          return _createElementVNode("li", null, [
            _createElementVNode("div", {
              class: "item",
              onClick: () => onMenuAction(icon.icon)
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: icon.icon
                }, null, 8, _hoisted_5)
              ]),
              _createElementVNode("div", _hoisted_6, _toDisplayString(icon.name), 1)
            ], 8, _hoisted_3)
          ])
        }), 64))
      ])
    ]),
    _: 1
  }))
}
}

})